module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.exportLoading),
      expression: "exportLoading"
    }],
    attrs: {
      "element-loading-text": "正在调整阀值"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', [_c('el-form-item', [_c('el-button', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportTable()
      }
    }
  }, [_vm._v("批量调整阀值")]), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.currmonthflowlimit),
      callback: function($$v) {
        _vm.currmonthflowlimit = $$v
      },
      expression: "currmonthflowlimit"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "margin-left": "5px"
    }
  }, [_c('i', {
    staticClass: "el-icon-warning-outline"
  }), _vm._v("流量阀值(MB)")])], 1)], 1)], 1), _vm._v(" "), _c('el-input', {
    staticClass: "textexport",
    attrs: {
      "type": "textarea",
      "rows": 20,
      "placeholder": _vm.placeholder
    },
    model: {
      value: (_vm.textarea),
      callback: function($$v) {
        _vm.textarea = $$v
      },
      expression: "textarea"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-5a3c6714!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/nav2/batch_flow.vue
// module id = 754
// module chunks = 2